import { Request } from "sp-react-commons";
import Uri from "../../../utils/Uri";

const API_ROOT = "/api/v1/mywort";
const API_PICTURE = API_ROOT + "/picture";

export class PictureApi {
    static uploadPicture = (data) => Request.uploadFile(API_PICTURE, data);
}

export class GroupApi {
    // Timestamp is here to avoid keeping pictures in browser cache
    static getGroupRawPictureUri = (groupId) => `${API_ROOT}/mygroups/${groupId}/rawPicture?r=${new Date().getTime()}`;
}

export class LocalityApi {
    static getNearestLocalities = (filters) => Request.get(Uri.buildQuery(`${API_ROOT}/localities/nearest`, filters));
}



// WEBPACK FOOTER //
// ./js/mywort/commons/api/Api.js